import { useNotes } from 'app/agriculture/queries/notes/useNotes';
import { useSelection } from 'app/agriculture/ContextMenu/hooks/useSelection/useSelection';
import { getAssetIconConfig } from 'app/agriculture/icons/utils/map-icon-utils/getAssetIconConfig';
import { createBillboardIconDataUri } from 'app/agriculture/icons/utils/map-icon-utils/createBillboardIconDataUri';
import { CesiumBillboard } from 'app/agriculture/FarmMain/MapRenderer/components/CesiumBillboard';
import { createIcon } from 'app/agriculture/hooks/useMapRender/mapRenderUtils';

export function NoteRenderer() {
    const notes = useNotes();
    const { isSelected } = useSelection();
    const { icon, options } = getAssetIconConfig('Note');
    if (!icon) throw new Error('icon cannot be found');
    const image = createBillboardIconDataUri(icon, options);

    return (
        <>
            {Array.from(notes).map(([id, { location }]) => {
                if (!location) return null;

                return (
                    <CesiumBillboard
                        key={id}
                        billboardOptions={createIcon({
                            id,
                            image,
                            coordinates: [location.longitude, location.latitude],
                            isPin: options?.billboardType === 'pin' || false,
                            isSelected: isSelected(id),
                        })}
                    />
                );
            })}
        </>
    );
}
